import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.loaded = false;
    this.element.addEventListener("mouseenter", this.loadTooltip.bind(this), { once: true });
  }

  async loadTooltip() {
    if (this.loaded) return;

    const purchaseId = this.data.get("purchaseId");

    try {
      const response = await fetch(`/purchases/${purchaseId}/tooltip`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!response.ok) return;

      const data = await response.json();
      this.updateTooltip(data);
      this.loaded = true;
    } catch (error) {
      console.error("Error loading tooltip:", error);
    }
  }

  updateTooltip(data) {
    const el = this.element;
    const lines = [
      `${el.dataset.labelBuyer}: ${this.truncate(data.purchaser_name, 25)}`,
      `${el.dataset.labelPhone}: ${data.phone}`,
      `${el.dataset.labelEmail}: ${data.email}`,
      `${el.dataset.labelProvider}: ${data.transporters_abbr}`,
      `${el.dataset.labelRound}: ${data.round_trip ? el.dataset.labelTrue : el.dataset.labelFalse}`,
      `${el.dataset.labelExchange}: ${data.exchange ? el.dataset.labelTrue : el.dataset.labelFalse}`,
      `${el.dataset.labelTicketTransfer}: ${data.ticket_transfer ? el.dataset.labelTrue : el.dataset.labelFalse}`,
      `${el.dataset.labelAttempts}: ${data.payment_attempts}`,
      `${el.dataset.labelNotes}: ${data.notes_count}`,
      `${el.dataset.labelCreatedAt}: ${data.created_at}`
    ];

    this.element.setAttribute("title", lines.join("\n"));
  }

  truncate(str, length) {
    if (!str) return "";
    return str.length > length ? str.substring(0, length) + "..." : str;
  }
}
